<template>
  <base-dialog :isOpen="dialogOpen" @closeDialog="toggleDialog">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{$t('invoices.new_adjunto')}}</h2>
          <base-tooltip-icon size="sm" :content="extensionTooltipMessage" class="ml-2"/>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4">
        <el-form
          :model="form"
          :rules="newRules"
          ref="ruleForm"
        >
        <div 
          class="px-2 mb-2 lg:mb-0 "
          :class="[isLower1024 ? '' : 'center']">
          <el-form-item prop="file" ref="fileRef">
            <Upload
                ref="upload"
                id="fileSelector"
                class="bg-white dark:bg-darkblue-900 dark:bg-darkblue "
                :class="[isLower1024 ? 'custom-upload-cert' : 'custom-upload ']"
                :accept="acceptAdjuntosExternos"
                drag
                multiple
                action="#"
                :auto-upload=false
                :on-progress="handleProgress"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :limit="maxFiles"
                :on-change="handleChange"
                :on-exceed="handleOnExceed"
                >
                <i class="el-icon-upload"></i>
                <p v-if="file.length" class="el-upload__text"><em>{{fileName}}</em></p>
                <div v-else class="el-upload__text" v-safe-html="$tc('app.upload_default_no_file_text', maxFiles)"></div>
            </Upload>
          </el-form-item>
        </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <div class="flex flex-row w-full justify-between space-x-2">
        <base-button @click="toggleDialog" mode="secondary-phantom-blue" class="w-full" :text="$t('app.cancel')"/>
        <base-button :disabled="disabledApply" mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="uploadNewDocument('ruleForm')"/>
      </div>
    </template>
  </base-dialog>
</template>

<script>
import { Upload } from 'element-ui'
import { subirAdjunto } from '@/services/invoices/subirAdjunto'
import { i18n } from '@/i18n'
import { EXTENSIONES_ADJ_EXTERNOS, EXTENSIONES_ADJ_EXTERNOS_FACEB2B } from '@/config/extensiones-adj-externos'

export default
{
  name: 'invoice-new-attachment-dialog',
  components: {
    Upload
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    idFacturae: {
      type: Number,
      default: -1
    },
    idInvoice: {
      type: Number,
      default: -1
    },
    pgeType: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      isOpen: this.dialogOpen,
      form: {
      },
      maxFiles: 5,
      maxSizeFile: 7340032, // Bytes (7MB)
      extensionesAdjuntosPermitidas: EXTENSIONES_ADJ_EXTERNOS,
      extensionesAdjuntosFaceb2b: EXTENSIONES_ADJ_EXTERNOS_FACEB2B,
      file: [],
      newRules: {
        file: [
          {
            required: true,
            message: i18n.t('validation.exceed_size_files_total') + ' (' + this.maxMB + ' MB)',
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.fileName) {
                let totalSize = 0
                this.file.forEach(x => {
                  totalSize = totalSize + x.size
                })
                if (totalSize > this.maxSizeFile) {
                  callback(new Error(i18n.t('validation.exceed_size_files_total') + ' (' + this.maxMB + ' MB)'))
                } else {
                  callback()
                }
              } else {
                callback()
              }
            }
          },
          {
            required: true,
            message: this.extensionRuleMessage,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              let invalidExtension = false
              this.file.forEach(archivo => {
                const extension = this.getExtensionFromFileName(archivo.name).toUpperCase()
                if (this.pgeType === 'FACEB2B') {
                  if (!this.extensionesAdjuntosFaceb2b.includes(extension)) {
                    invalidExtension = true
                  }
                  if (extension === 'ZIP' && this.file.length > 1) {
                    invalidExtension = true
                  }
                } else {
                  if (!this.extensionesAdjuntosPermitidas.includes(extension)) {
                    invalidExtension = true
                  }
                }
              })
              if (invalidExtension) {
                callback(new Error(this.extensionRuleMessage))
              } else {
                callback()
              }
            }
          },
        ]
      }
    }
  },
  mounted: async function () {
  },
  computed: {
    acceptAdjuntosExternos () {
      if (this.pgeType === 'FACEB2B') return 'application/xml,text/xml,application/pdf,application/zip'
      return 'application/pdf,text/html'
    },
    maxMB () {
      return this.maxSizeFile / 1024 / 1024
    },
    extensionRuleMessage: function () {
      if (this.form.pgeType === 'FACEB2B') {
        return i18n.t('validation.not_extension', { exts: this.extensionesAdjuntosFaceb2b.join(', ') }) + i18n.t('validation.onlyonce_zip')
      }
      return i18n.t('validation.not_extension', { exts: this.extensionesAdjuntosPermitidas.join(', ') })
    },
    extensionTooltipMessage: function () {
      return this.pgeType === 'FACEB2B' ? i18n.t('validation.max_files_faceb2b', { maxFilesAdj: this.maxFiles }) : i18n.t('validation.max_files', { maxFilesAdj: this.maxFiles }) + 
      i18n.t('validation.max_size_files', { maxMBAdj: this.maxMB }) +
      i18n.t('validation.extension', { exts: (this.pgeType === 'FACEB2B' ? this.extensionesAdjuntosFaceb2b : this.extensionesAdjuntosPermitidas).join(', ') })
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    fileName () {
      if (this.file === null || this.file.length === 0) {
        return ''
      } else if (this.file.length === 1) {
        return this.file[0].name
      } else {
        return i18n.tc('app.n_files', this.file.length)
      }
    },
    disabledApply: function () {
      return this.file === undefined || this.file === null || this.file.length === 0
    },
  },
  methods: {
    getExtensionFromFileName (fileName) {
      return fileName.split('.').at(-1)
    },
    toggleDialog: function () {
      this.isOpen = !this.isOpen
      this.file = []
      this.$emit('toggleDialog')
    },
    handleOnExceed: function () {
      this.doFeedback(i18n.t('validation.max_files_warn', { limit: this.maxFiles }), 'warning')
    },
    handleChange: function (file) {
      this.$refs.fileRef.clearValidate()
      this.file.push(file)
    },
    handleRemove: function (file) {
      this.file = this.file.filter(x => x.uid !== file.uid)
    },
    handlePreview: function () {
    },
    handleProgress: function (e) {
    },
    uploadNewDocument: async function (formName) {
      this.$refs[formName].validate(async (valid) => {
        try {
          if (valid) {
            if (this.idFacturae !== -1 && this.idInvoice !== -1) {
              const params = {
                idFacturae: this.idFacturae,
                idInvoice: this.idInvoice,
              }
              const response = await subirAdjunto(this.file, params)
              if (response.blnError === true) {
                this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
              } else {
                this.$emit('applyDialog')
                this.doFeedback(i18n.t('feedback.success.added_attachments_msg'), 'success')
                this.toggleDialog()
              }
            } else {
              this.$emit('applyDialog', this.file)
              this.doFeedback(i18n.t('feedback.success.added_attachments_msg'), 'success')
              this.toggleDialog()
            }
          } else {
            this.doFeedback(i18n.t('feedback.error.process_data_error'))
          }
        } catch (error) {
          const mensajeError = error?.response?.statusText
          if (mensajeError) {
            this.doFeedback(mensajeError)
          } else {
            this.doFeedback()
          }
        } finally {
          // this.toggleDialog()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.center {
  margin: auto;
  width: 60%;
  border: none;
  padding: 1px;
}

</style>
